/**
 *
 * @Description:
 * @Author: francklin
 * @Date: 2022.05.23
 *
 * Copyright (c) 2017-2021 duobaoyu, Inc. All rights reserved.
 * Unless required by applicable law or agreed to in writing,
 * Unauthorized use and distribution by any person or organization is prohibited.
 */

export default {
  computed: {
    //--
  },
  methods: {
    //--
  }
};
